import { render, staticRenderFns } from "./OnePayRedirect.vue?vue&type=template&id=b896d0fc&scoped=true&"
import script from "./OnePayRedirect.vue?vue&type=script&lang=js&"
export * from "./OnePayRedirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b896d0fc",
  null
  
)

export default component.exports